module.exports = __webpack_public_path__ + "static/media/darkOak.a632fb19.png";